import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Button, Toast, ToastBody, ToastHeader } from "reactstrap";
import confetti from "canvas-confetti";



const options3 = [
  "I am a business owner",
  "I am a business owner trialling this for my business",
  "I am an accountant setting this for a client",
  "I am an accountant trialing this for a client",
];



const Step1 = () => {
  const [showToast, setShowToast] = useState(false);
  const [suppliers, setSuppliers] = useState("");



  useEffect(() => {
    document.title = "Onboard | Bvo -Dashboard";
  }, []);



  const launchConfetti = () => {
    confetti({
      particleCount: 200,
      spread: 170,
      origin: { y: 0.6 },
    });

  };



  useEffect(() => {
    launchConfetti();
  }, []);



  // Save to localStorage based on the selected supplier option

  const handleSupplierChange = (option) => {
    setSuppliers(option);

   

    // Save the appropriate value to localStorage

    if (option === "I am a business owner" || option === "I am a business owner trialling this for my business") {
      localStorage.setItem("role", "Business Owner");
    } else if (option === "I am an accountant setting this for a client" || option === "I am an accountant trialing this for a client") {
      localStorage.setItem("role", "Accountant");

    }
  };



  return (

    <Container>

      <Row className="justify-content-center">
        <Col md={8} lg={8} xl={12}>
          <Card className="overflow-hidden">
            <div className="bg-primary text-center p-4">
              <h5 className="text-white font-size-20">About yourself</h5>
              <p className="text-white-50">Let's get you onboard.</p>
            </div>
            <CardBody>
              <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1050 }}>
                <Toast isOpen={showToast} fade>
                  <ToastHeader toggle={() => setShowToast(false)}>Notification</ToastHeader>
                  <ToastBody>🚀 Awesome, keep going!</ToastBody>
                </Toast>
              </div>



              <div className="p-3">
                <form className="mt-4">
                  <div className="mt-4 mb-3">
                    <label className="block mb-2 font-bold text-gray-700" style={{ fontSize: "1.2rem" }}>
                      How much of your business’s needs does your major supplier provide?
                    </label>
                    <div className="d-flex gap-3 flex-wrap">
                      {options3.map((option, index) => (
                        <div
                          key={index}
                          style={{ width: "220px", height: "200px" }}
                          className={`box flex items-center justify-center p-4 rounded-lg cursor-pointer ${
                            suppliers === option ? "selected bg-[#A3E566] text-blue" : "bg-gray-100 text-black"

                          }`}
                          onClick={() => handleSupplierChange(option)} // Call the handler when an option is clicked

                        >

                          {option}

                        </div>

                      ))}

                    </div>

                  </div>



                  {(suppliers === "I am a business owner" || suppliers === "I am a business owner trialling this for my business") && (

                    <div className="mb-3">

                      <label className="form-label" style={{ fontSize: "1.2rem" }}>Select Your Preferences</label>

                      {[

                        "Understand what my business is worth",

                        "Track changes in my business value over time",

                        "Monitor key business metrics in one place",

                        "Share insights with my accountant",

                        "Collaborate with my accountant in real-time"

                      ].map((label, index) => (

                        <div className="form-check" key={index}>

                          <input className="form-check-input" type="checkbox" id={`business-pref-${index}`} style={{ width: "1.2rem", height: "1.2rem" }} />

                          <label className="form-check-label" htmlFor={`business-pref-${index}`} style={{ fontSize: "1.1rem" }}>{label}</label>

                        </div>

                      ))}

                      <div className="form-check">

                        <input className="form-check-input" type="checkbox" id="other" style={{ width: "1.2rem", height: "1.2rem" }} />

                        <label className="form-check-label" htmlFor="other" style={{ fontSize: "1.1rem" }}>Other (please specify)</label>

                        <input type="text" className="form-control mt-2" placeholder="Specify here..." style={{ fontSize: "1.1rem" }} />

                      </div>

                    </div>

                  )}



                  {(suppliers === "I am an accountant setting this for a client" || suppliers === "I am an accountant trialing this for a client") && (

                    <div className="mb-3">

                      <label className="form-label" style={{ fontSize: "1.2rem" }}>Select Your Preferences</label>

                      {[

                        "I want to provide more value to my client",

                        "My client is considering an exit.",

                        "My client wants to improve the profitability of their business.",

                        "My client wants to understand their business value"

                      ].map((label, index) => (

                        <div className="form-check" key={index}>

                          <input className="form-check-input" type="checkbox" id={`accountant-pref-${index}`} style={{ width: "1.2rem", height: "1.2rem" }} />

                          <label className="form-check-label" htmlFor={`accountant-pref-${index}`} style={{ fontSize: "1.1rem" }}>{label}</label>

                        </div>

                      ))}

                    </div>

                  )}



                  <div className="mt-2 mb-0 row">

                    <div className="col-12 mt-4">

                      <p className="mb-0">

                        By registering you agree to the Bvo <Link to="#" className="text-primary">Terms of Use</Link>

                      </p>

                    </div>

                  </div>

                </form>

              </div>

            </CardBody>

          </Card>

        </Col>

      </Row>

    </Container>

  );

};



export default Step1;

